/** V1 godown move bags + count a bay strings (English), spread into en.ts. Hindi: v1-move-count.hi.ts. */
export const v1MoveCountEn = {
  'store.v1.move.title': 'Move bags',
  'store.v1.move.scanPlace': 'Scan the new place label',
  'store.v1.move.placeFirst':
    'First scan the label of the **new bay or spot** where the bags will go',
  'store.v1.move.onList': 'to move',
  'store.v1.move.from': 'from {place}',
  'store.v1.move.confirm': 'Bags moved',
  'store.v1.move.doneTitle': 'Bags moved',
  'store.v1.move.doneLine': '**{count}** {count:bag|bags} now at **{place}**',
  'store.v1.move.doneChip': 'The godown list shows them in the new place',
  'store.v1.move.replace': 'Torn bag / lost tag',
  'store.v1.count.bayTitle': 'Count a bay',
  'store.v1.count.scanPlace': 'Scan the place label',
  'store.v1.count.placeFirst': 'First scan the label of the **bay or spot** you will count',
  'store.v1.count.asked': 'The office asked for {count} {count:count|counts}: tap one',
  'store.v1.count.everyTag': "Scan **every bag's tag** here, one by one",
  'store.v1.count.counted': 'counted',
  'store.v1.count.band': '{grade} · {lot} · {n}/{m} seen',
  'store.v1.count.short': '{n} short',
  'store.v1.count.nothing': 'The phone expects no bags here',
  'store.v1.count.notExpected': '{count} {count:tag|tags} not expected here',
  'store.v1.count.extra': 'These bags should be somewhere else: {tags}',
  'store.v1.count.unknown': 'These codes are not bags in the godown: {tags}',
  'store.v1.count.placeLabel': 'That is a place label. Scan the tags on the bags.',
  'store.v1.count.done': 'Count done',
  'store.v1.count.doneMatch': 'Count matches',
  'store.v1.count.doneSaved': 'Count saved',
  'store.v1.count.doneLine': '**{seen}** of {expected} {expected:bag|bags} found at **{place}**',
  'store.v1.count.chipMatch': 'Matches the godown list',
  'store.v1.count.chipMismatch': 'Does not match the list: the office will see it',
  'store.v1.count.replace': 'Torn bag / lost tag here',
}

export type V1MoveCountMessageKey = keyof typeof v1MoveCountEn
